import { IContract, IProject } from 'store/projectContract.store';

interface Props {
    project: IProject;
    contract: IContract;
    setProject: (newProject: IProject) => void;
    setContract: (newContract: IContract) => void;
}

export const useProjectContractWithCustomSelectionFunc = ({ project, contract, setContract, setProject }: Props) => {
    const onSelectionFinish = ({ project, contract }: { project: IProject; contract: IContract }) => {
        setProject(project);
        setContract(contract);
    };

    return {
        contract,
        project,
        onSelectionFinish,
    };
};
